module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-11-1d303bfd62c866415fb9c42be1141233.png";